export const RENAME = 'RENAME';
export const MOVE = 'MOVE';
export const DELETE_FILE = 'DELETE_FILE';
export const DELETE_FOLDER = 'DELETE_FOLDER';
export const REPLACE_FILE = 'REPLACE_FILE';
export const PARTITION_FOLDER = 'PARTITION_FOLDER';
export const VIEW_FOLDER_ACCESS = 'VIEW_FOLDER_ACCESS';
export const ACADEMY_VIDEO = 'ACADEMY_VIDEO';
export const VIDEO_OPT_IN = 'VIDEO_OPT_IN';